import { Autocomplete, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { globalGetService, globalPutService } from "../../../../utils/globalApiServices";
import { updateClaimApi } from "../apiService";
import { checkApiStatus } from "../../../../utils";
import { useParams } from "react-router";
import { PageLoader } from "../../../../shared_elements";
import { trackActivity } from "../../../../utils/mixpanel";

const ClaimStatusChange = ({ statusModal, onToggleModal, getResponseBack, extraData }) => {
    const [data, setData] = useState(() => {
        if (statusModal?.data?.user) {
            const name = statusModal?.data?.user?.name || "";
            const [first_name = "", last_name = ""] = name.split(" ");
            return { ...statusModal?.data, user_id: { ...statusModal?.data?.user, first_name, last_name, }, };
        }
        return statusModal?.data;
    });
    const currentStatus=statusModal?.data?.status?.value;
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const [user, setUser] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [dropDownLoader,setDropDownLoader]=useState({user:false})
    const statusLabel = [{ value: 2, label: "In-Review" }, { value: 3, label: "Approved" }, { value: 4, label: "Rejected" }];
    useEffect(() => {
        if (!data?.user_id){
            getUserList() }
    }, [])
    const onFieldChange = (key, value) => {
        if (key === 'status') {
            setData({ ...data, [key]: value });
            setError({ ...error, [key]: "", 'reason': "" });
        }
        else {
            setData({ ...data, [key]: value });
            setError({ ...error, [key]: "" });
        }
    };
    const getUserList = () => {
        setDropDownLoader({user: true });
        globalGetService('/console/obligations/user_dropdown/')
            .then(response => {
                setDropDownLoader({user: false });
                if (checkApiStatus(response)) {
                    setLoading(false);
                    setUser(response?.data?.data);
                }
            })
    }
    const onApprovalStatus = () => {
        let validationInputs = {};
        validationInputs = {
            user_id: data?.user_id?.id ? "" : "Please select Approver",
            status: data?.status ? "" : "Please select Status",
            reason: data?.status?.value === 4 && currentStatus === 2 ? data?.reason ? "" : "Please enter Reason" : ''
        };
        let payload = Object.assign({}, data)
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data?.id) {
                globalPutService(updateClaimApi({ ...params, insuranceSlug: extraData?.slug, slug: data?.slug }), {
                    ...payload,
                    status: payload?.status?.value === 1 || currentStatus === 4 ? { value: 2, label: 'In-Review' } : payload?.status
                }).then(async (response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal();
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Claim Status`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Claim Status`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                    setLoading(false);
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item Edited`, { page_title:statusModal?.data?.status?.value === 1 ? "Select Approver" : "Change Claim Status", error_msg: validationInputs, })
        }
    };
const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title:statusModal?.data?.status?.value === 1 ? "Select Approver" : "Change Claim Status", page_type: page_type, })
    }
    return (<Box>
        <Dialog open={statusModal.modal}
            aria-labelledby="customized-dialog-title"
            className='add-lease-dialog' >
            <DialogTitle sx={{ m: 0, p: 2, }} className='dialog-header'>
                <Typography sx={{marginLeft: '10px'}}> {statusModal?.data?.status?.value === 1 ? "Select Approver" : "Change Claim Status"}</Typography>
            </DialogTitle>
            <DialogContent dividers style={{ width: "400px" }}>
                <Grid container spacing={2}>
                    <Grid item size={{ md: 12 }}>
                        <Autocomplete
                            disableClearable
                            disabled={currentStatus === 2}
                            options={user || []}
                            getOptionLabel={(option) => `${option?.first_name} ${option?.last_name}`}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            noOptionsText={dropDownLoader?.user ? "loading" : "No Option Available"}
                            filterOptions={(options, { inputValue }) =>
                                options.filter((option) =>
                                    `${option?.first_name} ${option?.last_name}`.toLowerCase().includes(inputValue.toLowerCase())
                                )
                            }
                            value={data?.user_id || null}
                            onChange={(e, value) => onFieldChange("user_id", value)}
                            renderOption={(props, option) => (
                                <Tooltip title={option?.email || ''} placement="right" arrow>
                                    <li {...props}>
                                        {option?.first_name} {option?.last_name}
                                    </li>
                                </Tooltip>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Approver"
                                    required
                                    size="small"
                                    error={!!error?.user_id}
                                    helperText={error?.user_id || ''}
                                    slotProps={{ inputLabel: { shrink: true },input:{ ...params?.InputProps,endAdornment: (<>{dropDownLoader?.user   ? ( <CircularProgress color="inherit" size={20} />) : null}{params?.InputProps?.endAdornment}</> ) }}}
                                />
                            )}
                        />
                    </Grid>
                    {statusModal?.data?.user_id ? <>
                        <Grid item size={{ md: 12 }}>
                            <Autocomplete
                                disableClearable
                                options={statusLabel}
                                value={data?.status || null}
                                getOptionLabel={(option) => option?.label || ""}
                                isOptionEqualToValue={(option, val) => option?.value === val?.value}
                                onChange={(e, value) => onFieldChange("status", value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        required
                                        size="small"
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        error={!!error?.status}
                                        helperText={error?.status || ''}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item size={{ md: 12 }}>
                            <TextField
                                id="status_change_reason"
                                label="Reason"
                                variant="outlined"
                                size='small'
                                value={data?.reason || ''}
                                onChange={(e) => onFieldChange('reason', e.target.value)}
                                required={data?.status?.value === 4}
                                margin='normal'
                                fullWidth
                                multiline
                                rows={3}
                                slotProps={{ inputLabel: { shrink: true } }}
                                error={error?.reason}
                                helperText={error?.reason || ''}
                            />
                        </Grid></> : null}
                </Grid>
            </DialogContent>
            <DialogActions className="dialog-action">
                <Button size="small" className="cancel-btn" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} color="primary" variant="outlined">Cancel</Button>
                <Button size="small" onClick={() => { handleItemClicked('Save Button'); onApprovalStatus(); }} color="primary" variant="contained" >{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>
            </DialogActions>
        </Dialog>
        {isLoading ? <PageLoader /> : null}
    </Box>
    )
}
export default ClaimStatusChange;